module.exports = __webpack_public_path__ + "static/media/08_alaska_temperature_map.0a801147.png";